// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('contacts.locations', {
        url: '/locations?currentPage&filter&pageSize&inactive&match',
        views: {
            "contactList@contacts": {
                templateUrl: 'main/contacts/locations/locations.tpl.html',
                controller: 'ContactsLocationsController as vm'
            }
        },
        resolve: {
            // locations: locationsResolver,
            searchTerms: searchTermResolver
        }
    });
}

// // @ngInject
// function locationsResolver(LocationsApiService) {
//     return LocationsApiService.listAll();
// }

// @ngInject
function searchTermResolver($stateParams) {
    return {
        filter: $stateParams.filter,
        currentPage: $stateParams.currentPage,
        pageSize: $stateParams.pageSize,
        inactive: $stateParams.inactive,
        match: $stateParams.match
    };
}

// @ngInject
function ContactsLocationsController(AuthService, $state, $stateParams, searchTerms, loadSpinnerService, LocationsApiService) {
    var vm = this;

    vm.isLoading = false;

    vm.locations = [];
    vm.goToLocation = goToLocation;
    vm.searchTermChange = searchTermChange;

    vm.filter = ($stateParams.filter === undefined) ? '' : $stateParams.filter; // "SearchTerm"
    vm.currentPage = 1;
    vm.pageSize = 15;
    vm.matchExactly = false;
    vm.inactive = false;
    vm.totalItems = [];

    activate();

    function activate() {
        searchTermChange();

        vm.filter = searchTerms.filter ? searchTerms.filter : '';
        vm.currentPage = searchTerms.currentPage > 1 ? searchTerms.currentPage : 1;
        vm.pageSize = searchTerms.pageSize >= 20 ? searchTerms.pageSize : 20;
        vm.matchExactly = searchTerms.match ? searchTerms.match == 'true' ? true : false : false;
        vm.inactive = searchTerms.inactive ? searchTerms.inactive == 'true' ? true : false : false;
    }

    function goToLocation(location) {
        if (AuthService.canAccess('location', 'read')) {
            $state.go('contacts.locations.location', {
                locationId: location.id
            });
        }
    }

    function searchTermChange() {
        if (vm.isLoading) { return; }

        console.log("searchTermChange()");

        if ($stateParams.filter && $stateParams.filter !== vm.filter) {
            vm.currentPage = 1;
        }

        $stateParams.filter = vm.filter;
        $stateParams.currentPage = vm.currentPage;
        $stateParams.pageSize = vm.pageSize;
        $stateParams.inactive = vm.inactive;
        $stateParams.match = vm.matchExactly;

        forceReloadUrl();

        if (vm.filter.length > 2) {
            loadLocations();
        } else if (vm.filter.length === 0) {
            loadLocations();
        }
    }

    function forceReloadUrl() {
        var params = {
            currentPage: vm.currentPage,
            pageSize: vm.pageSize,
            filter: $stateParams.filter,
            inactive: vm.inactive,
            match: vm.matchExactly
        };
        console.log("forceReloadUrl()", params);
        $state.go($state.current.name, 
        params,
        {notify: false}
        );
    }

    function loadLocations() {
        if(vm.isLoading) return;

        vm.isLoading = true;

        loadSpinnerService.start('mainSpinner');
        var request = {
            currentPage: vm.currentPage,
            filter: vm.filter,
            pageSize: vm.pageSize,
            showInactiveLocations: vm.inactive,
            matchEntireSearchTerm: vm.matchExactly
        };

        LocationsApiService.getLocations(request).then(function(response) {
            vm.locations = response.data.results;
            vm.totalItems = response.data.total;
            vm.pageSize = response.data.limit;
            vm.currentPage = response.data.page;

            $stateParams.filter = vm.filter;
            $stateParams.currentPage = vm.currentPage;
            $stateParams.pageSize = vm.pageSize;
            $stateParams.inactive = vm.inactive;
            $stateParams.match = vm.matchExactly;
        }).finally(function afterGetAllLocations() {
            loadSpinnerService.stop('mainSpinner',{force: true});
            if (vm.currentPage === 1 && vm.locations.length === 1 && vm.totalItems === 1) {
                goToLocation(vm.locations[0]);
            }
            vm.isLoading = false;
        });
    }
}

angular.module('contacts.locations', ['locations.api','contacts.locations.location'])
    .config(stateConfig)
    .controller('ContactsLocationsController', ContactsLocationsController);
